exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg[data-v-40e777e0]{width:48vw;height:48.8vw;margin:23.2vw auto 0 auto;display:block}.tip[data-v-40e777e0]{text-align:center;margin-top:-5.33333vw}", ""]);

// exports
